var shopPath = window.location.pathname;
console.log(JSON.stringify(window.location));
var cartIconBubble = document.querySelector('#cart-icon-bubble');
var shippingBar = document.querySelector('.shipping-bar-section #free-shipping-bar');

document.addEventListener("click", function (event) {
  if (event.target.matches(".button-minus-qty, .button-plus-qty")) {
    event.preventDefault();
    handleButtonClick(event);
    return;
  }
  if (event.target.matches(".quick-add__submit, .product-form__submit")) {
    if (event.target.closest('.quantity-input') || event.target.matches('.quantity-select') || event.target.matches('.quantity-input')) {
      return;
    }

    if (event.target.classList.contains('button__loading')) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    // Links / modal-openers (e.g. "Select Options") share the .quick-add__submit
    // class for styling but have no variant to add. handleButtonClick() requires
    // data-vid (and crashes without it), so let these run their default action.
    if (!event.target.hasAttribute('data-vid')) {
      return;
    }

    event.preventDefault();
    handleButtonClick(event);
  }
});

document.addEventListener("focus", function (event) {
  if (event.target.matches(".quantity-input") && event.target.type === "number") {
    setTimeout(function () {
      event.target.select();
    }, 0);
  }
}, true);

document.addEventListener("blur", function (event) {
  if (event.target.matches(".quantity-input")) {
    handleInputBlur(event);
  }
}, true);

document.addEventListener("keydown", function (event) {
  if (event.target.matches(".quantity-input")) {

    const isModifierPressed = event.ctrlKey || event.metaKey;

    if (!event.key.match(/^[0-9]$/) && !["Enter", "Tab", "Backspace", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key) && !isModifierPressed) {
      event.preventDefault();
    } else if (event.key === "Enter" && !isModifierPressed) {
      event.preventDefault();
      event.target.blur();
    }
  }
}, true);


function getCurrentPage() {
  const urlParams = new URLSearchParams(window.location.search);
  return parseInt(urlParams.get('page')) || 1;
}

function handleInputBlur(event) {
  let input = event.target;
  let variantId = input.getAttribute('data-vid').toString();

  let currQty = parseInt(input.getAttribute('data-current-qty'), 10);
  let newQty = parseInt(input.value, 10);

  if (newQty !== currQty) {
    let submitButton = submitButtonType(event.target);

    checkRestrictions(variantId, currQty, newQty, submitButton);
  }
}

function handleButtonClick(event) {
  let input = event.target;
  let parent = input.parentElement;
  let variantId = input.getAttribute('data-vid').toString();
  let submitButton = submitButtonType(input);
  var qtyInput = parent.querySelector('.quantity-input');
  let currQty = qtyInput ? parseInt(qtyInput.value) : 0;
  let newQty = parseInt(event.target.getAttribute('data-qty'));

  checkRestrictions(variantId, currQty, newQty, submitButton);
}


function submitButtonType(target) {
  let submitButton = null;
  let productForm = null;

  if (shopPath.includes('/products/')) {
    // Try to find the product form using different selectors
    productForm = target.closest('.product-form, product-form');
    if (productForm) {
      submitButton = productForm.querySelector('.product-form__submit, .quick-add__submit');
    }
  } else {
    let quickAdd = target.closest('.quick-add');
    if (!quickAdd) {
      // Try to find the form in case 'quick-add' is not present
      quickAdd = target.closest('product-form, .product-form');
    }
    if (quickAdd) {
      submitButton = quickAdd.querySelector('.quick-add__submit, .product-form__submit');
    }
  }

  return submitButton;
}

function checkRestrictions(variantId, currQty, newQty, submitButton) {
  var cartRoute = currQty === 0 ? routes.cart_add_url : routes.cart_change_url;

  var productForm = submitButton.closest('.quick-add');
  if (shopPath.includes('/products/')) {
    productForm = submitButton.closest('.product-form');
  }

  const restrictionsEnabled = productForm && productForm.dataset.restrictionsEnabled === 'true';
  const quantityLimit = productForm ? parseInt(productForm.dataset.quantityLimit, 10) : null;

  if (restrictionsEnabled && quantityLimit !== null && (currQty + newQty) > quantityLimit) {
    const quantityInput = productForm.querySelector(`.quantity-input[data-vid="${variantId}"]`);
    if (quantityInput) {
      quantityInput.value = quantityLimit;
    }
    displayError(productForm, `You can only add ${quantityLimit} of this item to your cart.`);
    if (currQty == quantityLimit) {
      return;
    }
    cartRoute = routes.cart_change_url;
  }

  console.log(variantId);
  console.log(submitButton);
  console.log(cartRoute);
  updateCart(variantId, currQty, newQty, submitButton, cartRoute);
}

function displayError(productForm, message) {
  const errorBox = productForm.querySelector(".product-form__error");
  if (errorBox) {
    errorBox.removeAttribute("hidden");
    const errorText = errorBox.querySelector(".product-form__error-message");
    errorText.textContent = message;
  }
}

function updateCart(variantId, currQty, newQty, submitButton, cartRoute) {
  submitButton.classList.add("button__loading");
  let buttonTarget = submitButton.closest('.product-form__buttons');
  let sectionsArray = ["free-shipping-bar", "cart-icon-bubble"];
  let promoSectionId = null;
  var promoBarEl = document.querySelector('#promo-threshold-bar');
  if (promoBarEl) {
    promoSectionId = promoBarEl.getAttribute('data-section-id') || 'promo-threshold-bar';
    sectionsArray.push(promoSectionId);
  }
  var cartDrawerElement = document.querySelector('cart-drawer');
  if (cartDrawerElement) {
    sectionsArray.push('cart-drawer');
  }
  let sectionKey = 'slide-product';

  const urlParams = window.location.search;
  let sectionsUrlWithPage = `${shopPath}${urlParams}`;

  if (shopPath.includes('pages/recommended')) {
    sectionsArray.push("recommended-product");
    sectionKey = 'recommended-product';
  } else if (shopPath.includes('/search')) {
    console.log('search page');
  } else if (shopPath.includes('collections')) {
    sectionsArray.push("card-product");
    sectionKey = 'card-product';
  } else if (shopPath.includes('/products/')) {
    sectionsArray.push("add-to-cart");
    sectionKey = 'add-to-cart';
  } else {
    sectionsArray.push("slide-product");
  }

  const body = JSON.stringify({
    id: variantId,
    quantity: newQty,
    sections: sectionsArray,
    sections_url: sectionsUrlWithPage
  });

  fetch(cartRoute, { ...fetchConfig(), ...{ body } })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorBody => Promise.reject(errorBody));
      }
      return response.text();
    })
    .then(state => {
      const parsedState = JSON.parse(state);

      // Handle cart and shipping bar updates
      let parser = new DOMParser();

      let miniCartHTML = parsedState.sections["cart-icon-bubble"];
      if (cartIconBubble && miniCartHTML) {
        cartIconBubble.innerHTML = miniCartHTML;
      }

      if (shippingBar) {
        let barHTML = parsedState.sections["free-shipping-bar"];
        if (barHTML) {
          let parsedBarHTML = parser.parseFromString(barHTML, 'text/html');
          let shippingBarElement = parsedBarHTML.querySelector('#free-shipping-bar .bar-inner');
          if (shippingBarElement) {
            shippingBar.innerHTML = shippingBarElement.outerHTML;
            document.dispatchEvent(new Event('updateShippingBar'));
          }
        }
      }

      // Update cart drawer contents
      if (cartDrawerElement && parsedState.sections["cart-drawer"]) {
        try {
          const cartDrawerHTML = parser.parseFromString(parsedState.sections["cart-drawer"], 'text/html');
          const newCartDrawer = cartDrawerHTML.querySelector('cart-drawer');
          const newCartDrawerInner = cartDrawerHTML.querySelector('#CartDrawer');
          const currentCartDrawerInner = document.querySelector('#CartDrawer');
          if (newCartDrawerInner && currentCartDrawerInner) {
            currentCartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
            if (newCartDrawer) {
              cartDrawerElement.classList.toggle('is-empty', newCartDrawer.classList.contains('is-empty'));
            }
          }
        } catch (e) {
          console.error('Cart drawer update failed:', e);
        }
      }

      // Update promo threshold bar
      try {
        if (promoSectionId) {
          let promoBarHTML = parsedState.sections[promoSectionId];
          if (promoBarHTML) {
            let parsedPromoHTML = parser.parseFromString(promoBarHTML, 'text/html');
            let promoBarElement = parsedPromoHTML.querySelector('#promo-threshold-bar .promo-bar-inner');
            let promoBar = document.querySelector('#promo-threshold-bar');
            if (promoBarElement && promoBar) {
              promoBar.innerHTML = promoBarElement.outerHTML;
              document.dispatchEvent(new Event('updatePromoBar'));
            }
          }
        }
      } catch (e) {
        console.error('Promo bar update failed:', e);
      }

      // If we're on search, update the button by re-fetching the current page
      if (shopPath.includes('/search')) {
        // Apply temporary styling
        if (buttonTarget) {
          buttonTarget.style.opacity = '0.6';
          buttonTarget.style.pointerEvents = 'none';
          buttonTarget.style.cursor = 'not-allowed';
        }

        fetch(window.location.href)
          .then(response => response.text())
          .then(html => {
            const tempDoc = parser.parseFromString(html, 'text/html');
            const newButton = tempDoc.querySelector(`.card-product-${variantId} .product-form__buttons`);
            if (newButton && buttonTarget) {
              buttonTarget.innerHTML = newButton.innerHTML;
              // Reset styles after update
              buttonTarget.style.opacity = '';
              buttonTarget.style.pointerEvents = '';
              buttonTarget.style.cursor = '';
            }
          });
      } else {
        // Handle other sections as normal
        let parseHTML = parsedState.sections[sectionKey];
        let buttonHTML = getButtonHTML(variantId, parseHTML);
        if (buttonHTML) {
          buttonTarget.innerHTML = buttonHTML;
        }
      }

      submitButton.classList.remove("button__loading");
    })
    .catch(error => {
      console.error('Error in updateCart:', error);
      submitButton.classList.remove("button__loading");
    });
}

function getButtonHTML(variantId, htmlString) {
  console.log('getButtonHTML called with variantId:', variantId);
  console.log('Current shopPath:', shopPath);

  let parser = new DOMParser();
  let doc = parser.parseFromString(htmlString, 'text/html');

  let productDetails;
  if (shopPath.includes('/products/')) {
    productDetails = doc.querySelector(`product-form`);
    console.log('Product page - found productDetails:', !!productDetails);
  } else if (shopPath.includes('/search')) {
    // For search results, find the specific product card by variant ID
    productDetails = doc.querySelector(`#product-grid .card-product-${variantId}`);
    console.log('Search page - looking for:', `#product-grid .card-product-${variantId}`);
    console.log('Search page - found productDetails:', !!productDetails);
    // Log the full HTML to inspect structure
    console.log('Parsed HTML structure:', doc.body.innerHTML);
  } else {
    productDetails = doc.querySelector(`.card-product-${variantId}`);
    console.log('Other page - found productDetails:', !!productDetails);
  }

  if (productDetails) {
    let productFormButtons = productDetails.querySelector('.product-form__buttons');
    console.log('Found product form buttons:', !!productFormButtons);
    if (productFormButtons) {
      console.log('Button HTML found:', productFormButtons.innerHTML);
      return productFormButtons.innerHTML;
    }
  }
  console.log('No button HTML found');
  return null;
}
